import {
  IconArrowLeft,
  IconComponentImage,
  IconText,
  NiceModalHandler,
  SpaceBetween,
  spacing,
  styled,
} from '@lessonup/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { GeneratorInputType } from '../../../../ChatGPTGenerator/MaiaGenerateLesson';
import { TRANSLATION_NAMESPACE } from '../constants';
import { Footer } from './Footer';
import { LessonModalContent, LessonModalMainWrapper } from './LayoutComponents';
import { OptionCard } from './OptionCard';

interface GenerateLessonProps {
  modal: NiceModalHandler<Record<string, unknown>>;
  editorType: 'v1' | 'v2';
  back: () => void;
}

export const GenerateLesson: React.FC<GenerateLessonProps> = ({ modal, editorType, back }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE, { keyPrefix: 'generateLesson' });

  const handleStartMaia = (type: GeneratorInputType) => {
    modal.resolve({ type: 'maia', generatorType: type, version: editorType });
    modal.hide();
  };

  return (
    <LessonModalMainWrapper>
      <LessonModalContent>
        <StyledSpaceBetween direction="y" spacing={spacing.size8}>
          <OptionCard
            title={t('generateLesson.maiaTextTitle')}
            taglineIcon={<IconText />}
            tagline={t('generateLesson.maiaTextTagline')}
            description={t('generateLesson.maiaTextContent')}
            onClick={() => handleStartMaia('text')}
          />
          <OptionCard
            title={t('generateLesson.maiaImageTitle')}
            taglineIcon={<IconComponentImage />}
            tagline={t('generateLesson.maiaImageTagline')}
            description={t('generateLesson.maiaImageContent')}
            onClick={() => handleStartMaia('upload')}
          />
        </StyledSpaceBetween>
      </LessonModalContent>
      <Footer backButton={{ onClick: back, label: t('back'), iconStart: <IconArrowLeft /> }} />
    </LessonModalMainWrapper>
  );
};

const StyledSpaceBetween = styled(SpaceBetween)`
  height: 100%;
  flex-grow: 1;
  display: flex;
  justify-content: space-between;

  > * {
    flex: 1;
  }
`;
